module.exports = "/_next/static/images/d9a71f6ee492267acd3a5d0da7316468-savings-without-logos-lg-2x.jpg.webp";